// How the cache keeps the listings of files that come a page at a time. Each folder's listing, and
// Starred's, is kept as one list under its place and search, whatever page was asked for, so the
// pages scrolled to so far read back as one. A page asked for past the last one is added to the end
// of it; anything else (the first ask, or asking again from the top) replaces it outright. Asking
// again from the top asks for as many files as are kept, so the list doesn't shrink back to one
// page; "usePagedUploads" sees to that.
const pagedUploads = keyArgs => ({
  keyArgs,
  merge: (existing, incoming, {args, readField}) => {
    if (!args?.after || !existing) return incoming

    const kept = new Set(existing.nodes.map(node => readField('id', node)))

    return {...incoming, nodes: [...existing.nodes, ...incoming.nodes.filter(node => !kept.has(readField('id', node)))]}
  }
})

const typePolicies = {
  Query: {
    fields: {
      uploads: pagedUploads(['folderId', 'search']),
      starredUploads: pagedUploads(['search'])
    }
  }
}

export default typePolicies
